<script>
import gridComponent from "./Grid.vue";
import listComponent from "./List.vue";
import TableActionRow from "./components/TableActionRow/TableActionRow";
import ClientCreateModal from "../../components/modals/ClientCreateModal.vue";
import ClientInviteModal from "../../components/modals/ClientInviteModal.vue";
import MassClientCreateModal from "../../components/modals/MassClientCreateModal.vue";
import axios from "axios";
import OnBoardingChecklistModal from "./components/OnboardingChecklist/OnBoardingChecklistModal.vue";
import { Inertia } from '@inertiajs/inertia';

export default {
    components: { gridComponent, listComponent, TableActionRow, ClientCreateModal, ClientInviteModal, MassClientCreateModal, OnBoardingChecklistModal },
    props: {
        all_user: {
            type: Array,
            default: function() {
                return []
            }
        },
        paginationDetails: {
            type: Object,
            default: function() {
                return {}
            }
        },
        filters: {
            type: Object,
            default: function() {
                return {}
            }
        },
        referralDetails: {
            type: Array,
            default: function() {
                return []
            }
        },
        intakeLinkDetails: {
            type: Array,
            default: function() {
                return []
            }
        },
        allStripePlans: {
            type: Object,
            default: function() {
                return {}
            }
        },
        clientListType: {
            type: String,
            default: function () {
                return null;
            },
        },
        modalTitle: {
            type: String,
            default: function () {
                return null;
            },
        },
        createClientRoute: {
            type: String,
            default: function () {
                return null;
            },
        },
        inviteClientRoute: {
            type: String,
            default: function () {
                return null;
            },
        },
        importCsvToInviteRoute: {
            type: String,
            default: function () {
                return null;
            },
        },
        exportCsvUrl: {
            type: String,
            default: function () {
                return null;
            },
        },
        exportCsvFilename: {
            type: String,
            default: function () {
                return null;
            },
        },
        type: {
            type: Number,
            default: 0
        },
        submitType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            viewType: "list",
            search: this.filters.search ? this.filters.search : null,
            downloadExcel: [],
            exportLoader: false,
            showClientCreateModal: false,
            showInvitationModal: false,
            showMassClientCreateModal: false,
            showOnboardingChecklistModal: false,
            onBoardingChecklistItems: []
        };
    },
    methods: {
        toggleList() {
            this.viewType = this.viewType === "list" ? "grid" : "list";
        },

        async exportDataFetch() {
            let queryString = window.location.href.split("?");
            let url = this.exportCsvUrl;
            if (queryString.length > 1) {
                url += "?" + queryString[1];
            }
            const response = await axios.get(url);
            return response.data;
        },

        startDownload() {
            this.exportLoader = true;
        },

        finishDownload() {
            this.exportLoader = false;
        },

        showAddClientModalFunc() {
            this.showClientCreateModal = true;
        },

        hideAddClientModalFunc() {
            this.showClientCreateModal = false;
        },

        showMassClientCreateModalFunc() {
            this.showMassClientCreateModal = true
        },

        hideMassClientCreateModalFunc() {
            this.showMassClientCreateModal = false
        },

        showInvitationModalFunc() {
            this.showInvitationModal = true;
            this.customizeReferralLink = false;
        },

        hideInviteClientModalFunc() {
            this.showInvitationModal = false;
        },
        showOnboardingChecklistModalFunc(value, items) {
            this.showOnboardingChecklistModal = value;
            this.onBoardingChecklistItems = items;
        },
        reloadPage() {
            Inertia.reload();
        }
    },
    computed: {
        currentComponent() {
            return this.viewType === "list" ? listComponent : gridComponent;
        },
        isShowCreateInviteButton() {
            return this.createClientRoute != null
        },
    },

    watch: {
        search: function (newVal) {
            let queryString = window.location.href.split("?");
            this.$inertia.get(
                queryString[0],
                { search: newVal },
                {
                    preserveState: true,
                }
            );
        },
    },
};
</script>

<template>
    <div>
        <TableActionRow
            :addClientClick="showAddClientModalFunc"
            :addInviteClick="showInvitationModalFunc"
            :massAddClientClick="showMassClientCreateModalFunc"
            :exportLoader="exportLoader"
            :exportDataFetch="exportDataFetch"
            :startDownload="startDownload"
            :finishDownload="finishDownload"
            :viewType="viewType"
            :toggleList="toggleList"
            :search="search"
            @searchUsers="search = $event"
            :exportCsvFilename="exportCsvFilename"
            :isShowCreateInviteButton="isShowCreateInviteButton"
        />

        <component
            :is="currentComponent"
            :all_user="all_user"
            :paginationDetails="paginationDetails"
            :allStripePlans="allStripePlans"
            :clientListType="clientListType"
            :showOnboardingChecklistModalFunc="showOnboardingChecklistModalFunc"
        />

        <ClientCreateModal 
            v-if="isShowCreateInviteButton"
            :showModal="showClientCreateModal"
            :modalTitle="modalTitle"
            @onClose="hideAddClientModalFunc"
            :createClientRoute="createClientRoute"
            :clientListType="clientListType"
        />

        <MassClientCreateModal
            v-if="isShowCreateInviteButton"
            :showModal="showMassClientCreateModal"
            :modalTitle="modalTitle"
            @onClose="hideMassClientCreateModalFunc"
            :type="type"
            :submitType="submitType"
        />

        <ClientInviteModal 
            v-if="isShowCreateInviteButton"
            :showModal="showInvitationModal"
            :modalTitle="modalTitle"
            @onCloseInviteModal="hideInviteClientModalFunc"
            :referralDetails="referralDetails"
            :intakeLinkDetails="intakeLinkDetails"
            :inviteClientRoute="inviteClientRoute"
            :importCsvToInviteRoute="importCsvToInviteRoute"
        />
        <OnBoardingChecklistModal 
            :isShow="showOnboardingChecklistModal" 
            :showModal="showOnboardingChecklistModalFunc"
            :onBoardingChecklistItems="onBoardingChecklistItems"
            :reloadPage="reloadPage"
        />        
    </div>
</template>
